jQuery(document).ready(function($){
    setTimeout(() => {
        $('.related-products__list').owlCarousel({
            margin:24,
            dots:true,
            responsive:{
                0:{
                    items:2
                },
                750:{
                    items:3
                }
            }
        })
    }, 3000);
    $(window).on('scroll', function() {
        var heightHeader = $('.announcement-bar-section').height() + $('.header-wrapper').height();
        var heightSticky = $('.header-wrapper').height();
        if ($(this).scrollTop() > heightHeader) {
            $('body').addClass('body-scrolled');
        }
        if ($(this).scrollTop() < heightSticky) {
            $('body').removeClass('body-scrolled');
        }
    });

    if ($(window).width() < 750) {
        var $listMenu = $("header-drawer .menu-drawer__navigation > .list-menu");
        var all_class = $("header-drawer .list-menu li:last-of-type a").attr('class')
        $(".announcement-link a").each(function() {
            var $li = $("<li></li>");
            $li.append($(this).detach());
            $listMenu.append($li);
            $("header-drawer .list-menu a").addClass(all_class)
        });
    }

    $('#HeaderDrawer-brands').click(function () {
        $('.slick-carousel.is_mobile').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });

        $('.slick-pagination.is_mobile a').click(function () {
            const slideIndex = $(this).data('slide');
            if (slideIndex !== '') {
                $('.slick-carousel.is_mobile').slick('slickGoTo', slideIndex);
            }
        });
    });

    $(".mega-menu").hover(
        function() {
            $(this).attr('open', '');
            $(this).find('summary').attr("aria-expanded","true");
            if ($(this).find('summary').hasClass("brands")) {
                $('.slick-carousel.is_desktop').slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false,
                });
                $('.slick-pagination.is_desktop button').click(function () {
                    const slideIndex = $(this).data('slide');
                    if (slideIndex !== '') {
                        $('.slick-carousel').slick('slickGoTo', slideIndex);
                    }
                });
                setTimeout(() => {
                    $('.is_brands.is_desktop').css('opacity', '1');
                }, 500);
            }
        },
        function() {
            $(this).removeAttr('open');
            $(this).find('.summary').attr("aria-expanded","false");
        }

    );

    $('.variant__select-color').change(function(){
        const selectedValue = $(this).val();

        document.querySelectorAll('.variant__list-color input[type="radio"]').forEach((item) => {
            item.removeAttribute('checked');
        });

        if (selectedValue) {
            document.querySelector(`[value='${selectedValue}']`).setAttribute('checked', true);
        }
    })
});
